import CryptoJS from "crypto-js"
import {ORDER_DATA_ENCRYPT_KEY, ORDER_DATA_ENCRYPT_IV} from '../constant/common'

const key = CryptoJS.enc.Utf8.parse(ORDER_DATA_ENCRYPT_KEY) // 慎重修改
const iv = CryptoJS.enc.Utf8.parse(ORDER_DATA_ENCRYPT_IV) // 慎重修改
export function AESEncrypt(str) {
  let res = '';
  try {
    res = CryptoJS.AES.encrypt(str, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
  } catch (e) {
    console.warn('AESEncrypt Error: ', e)
  }
  return res
}

export function AESDecrypt(encryptedStr) {
  const key = CryptoJS.enc.Utf8.parse(ORDER_DATA_ENCRYPT_KEY) // 慎重修改
  const iv = CryptoJS.enc.Utf8.parse(ORDER_DATA_ENCRYPT_IV) // 慎重修改
  const decrypted = CryptoJS.AES.decrypt(encryptedStr, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}
